import './styles.css';
import { hideBootScreen, showBootError } from './core/Assets';
import { Game } from './core/Game';

const canvas = document.getElementById('viewport') as HTMLCanvasElement | null;
const uiRoot = document.getElementById('ui-root') as HTMLElement | null;

if (!canvas || !uiRoot) {
  showBootError(new Error('Magnetic Hound could not find its canvas or UI root.'));
} else {
  try {
    const game = new Game(canvas, uiRoot);
    game.start();
    window.magneticHound = game;
    requestAnimationFrame(() => requestAnimationFrame(hideBootScreen));
  } catch (error) {
    console.error(error);
    showBootError(error);
  }
}

// Exposed for the automated smoke test (see docs/TESTING.md section 4).
declare global {
  interface Window {
    magneticHound?: Game;
  }
}
